export const BOOKING_INDEX = 'BOOKING_INDEX';
export const BOOKING_LOADING_INDEX = 'BOOKING_LOADING_INDEX';
export const BOOKING_LOADING_SHOW = 'BOOKING_LOADING_SHOW';
export const BOOKING_RESET = 'BOOKING_RESET';
export const BOOKING_SEARCH = 'BOOKING_SEARCH';
export const BOOKING_SHOW = 'BOOKING_SHOW';
export const BOOKING_SETTING = 'BOOKING_SETTING';
